import { useState } from "react";
import Button from "@mui/material/Button";
import {
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
} from "@mui/material";
import { CheckCircle, Warning } from "@mui/icons-material";
import { QualityCheck } from "../erp/manufacturing/Product";
import OdooOperationsService from "../erp/manufacturing/OdooOperationsService";

interface QualityAlertButtonProps {
	svc: OdooOperationsService;
	qualityCheck: QualityCheck;
	disabled?: boolean;
	onError(error: Error): void;
	onClick(): Promise<void>;
	onDone(qualityAlertRef: string): void;
}

export function QualityAlertButton(props: QualityAlertButtonProps) {
	const { svc, qualityCheck, disabled, onError, onClick, onDone } = props;

	const [state, setState] = useState<undefined | "busy" | "success" | "failed">(
		undefined,
	);

	const [qualityAlertDialogOpen, setQualityAlertDialogOpen] =
		useState<boolean>(false);
	const [qualityAlertDescription, setQualityAlertDescription] =
		useState<string>("");
	const [qualityAlertRef, setQualityAlertRef] = useState<string>();

	return (
		<>
			<Button
				variant="contained"
				sx={{ backgroundColor: "#ffd300", color: "black" }}
				fullWidth
				disabled={disabled || state === "busy"}
				onClick={async () => {
					setQualityAlertDialogOpen(true);
				}}
			>
				{state === "busy" && <CircularProgress size="1em" />}
				{state === "failed" && <Warning />}
				{state === "success" && <CheckCircle />}
				&nbsp;Quality Alert{qualityAlertRef ? ` (${qualityAlertRef})` : null}
			</Button>
			{qualityAlertDialogOpen && (
				<Dialog
					open={true}
					onClose={() => {
						setQualityAlertDialogOpen(false);
					}}
					fullWidth
					maxWidth="sm"
				>
					<DialogTitle>
						Quality Alert{qualityAlertRef ? ` (${qualityAlertRef})` : null}
					</DialogTitle>
					<DialogContent>
						<TextField
							multiline
							fullWidth
							minRows={3}
							maxRows={3}
							label="Description"
							onChange={(event) =>
								setQualityAlertDescription(event.target.value)
							}
							onKeyDown={(event) => event.stopPropagation()}
							margin="dense"
							disabled={qualityAlertRef !== undefined}
						/>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={() => {
								setQualityAlertDialogOpen(false);
							}}
						>
							Cancel
						</Button>
						<Button
							disabled={qualityAlertDescription === "" || state === "busy"}
							onClick={async () => {
								setState("busy");
								try {
									const result: any = await svc.callKw(
										"quality.check",
										"rc_quality_alert",
										[qualityCheck.id as any],
										{ description: qualityAlertDescription },
									);
									const newQualityAlertRef = result.qualityAlertRef;
									setQualityAlertRef(newQualityAlertRef);
									await onClick();
									onDone(newQualityAlertRef);
									setState("success");
								} catch (error) {
									setState("failed");
									onError(error as Error);
								}
							}}
						>
							{state === "busy" && <CircularProgress size="1em" />}
							&nbsp;Create
						</Button>
					</DialogActions>
				</Dialog>
			)}
		</>
	);
}
